import { render, staticRenderFns } from "./BusinessRegisterForm.vue?vue&type=template&id=7b742f4f&scoped=true&"
import script from "./BusinessRegisterForm.vue?vue&type=script&lang=js&"
export * from "./BusinessRegisterForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegisterForm.vue?vue&type=style&index=0&id=7b742f4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b742f4f",
  null
  
)

export default component.exports